export default {
  getRestaurantOrders: 'GET_RESTAURANT_ORDERS',
  getRestaurantOrdersSuccess: 'GET_RESTAURANT_ORDERS_SUCCESS',
  getRestaurantOrdersFailed: 'GET_RESTAURANT_ORDERS_FAILED',
  resetToInitialState: 'RESTAURANT_ORDERS_RESET_TO_INITIAL_STATE',
  updateCompanyOrderStatus: 'UPDATE_COMPANY_ORDER_STATUS',
  updateCompanyOrderStatusSuccess: 'UPDATE_COMPANY_ORDER_STATUS_SUCCESS',
  updateCompanyOrderStatusFailed: 'UPDATE_COMPANY_ORDER_STATUS_FAILED',
  togglePrintStickersModal: 'TOGGLE_PRINT_STICKER_MODAL'
};
